import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminUsersService } from '../../admin-users/services/admin-users.service';
import { AuthDataStorageService } from '../services/auth-data-storage.service';

@Component({
  selector: 'ch-totp',
  templateUrl: './totp.component.html',
  styleUrls: ['./totp.component.css'],
})
export class TotpComponent implements OnInit {
  public loading: boolean;
  public qrCode: string;
  private id: string;

  constructor(private authDataStorageService: AuthDataStorageService, private adminUsersService: AdminUsersService, private router: Router) {}

  ngOnInit() {
    this.id = this.authDataStorageService.getLoggedUserId();
  }

  public enable2fa() {
    this.loading = true;
    this.adminUsersService.enabled2fa(this.id).subscribe(
      data => {
        this.qrCode = data.text();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  public continue() {
    if (confirm("Make sure you have correctly added the 2FA to the authenticator app. Once you continue, you won't be able to see the QR code again. Are you sure you want to continue?")) {
      this.router.navigateByUrl('/admin/dashboard');
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/auth/totp/totp.component.ts